import styled from "styled-components";
import { Button, colors } from "@streeteasy/design-system";
import { Body } from "@streeteasy/design-system/typography";

const { BRAND, WHITE } = colors;

export const VoucherBadgeContainer = styled.div`
  align-items: center;
  display: flex;
  text-align: center;
`;

export const VoucherBadgeText = styled(Body)`
  flex: 1 1 auto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  padding-right: 6px;
`;

export const VoucherButton = styled(Button)`
  background: none;
  border: none;
  color: ${BRAND};
  flex: 1 1 auto;
  height: 100%;
  min-width: auto;
  padding: 0;
  white-space: nowrap;

  &:hover {
    background-color: ${WHITE};
  }
`;
